import { render, staticRenderFns } from "./PollyPost.vue?vue&type=template&id=7479a644&scoped=true&"
import script from "./PollyPost.vue?vue&type=script&lang=js&"
export * from "./PollyPost.vue?vue&type=script&lang=js&"
import style0 from "./PollyPost.vue?vue&type=style&index=0&id=7479a644&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7479a644",
  null
  
)

export default component.exports